module.exports = require("@xterm-stack/core");